import env from '../../package.json';

function getOrigin() {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  // SSR fallback
  return env.nodeHost || 'http://localhost:3000';
}

export const keycloakConfig = {
  serverUrl: env.keycloakAPI?.serverUrl || process.env.REACT_APP_KEYCLOAK_SERVER_URL,
  nextUrl: getOrigin(),
  clientId: env.keycloakAPI?.clientID || process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'events-client',
  clientSecret: env.keycloakAPI?.clientSecret || process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET,
  realm: env.keycloakAPI?.realm || process.env.REACT_APP_KEYCLOAK_REALM || 'events',
  keycloakUrl: env.keycloakAPI?.keycloakUrl || process.env.REACT_APP_KEYCLOAK_SERVER_URL || 'https://auth.edro.su',
  redirectUri: `${getOrigin()}${env.keycloakAPI?.redirectUri || process.env.REACT_APP_KEYCLOAK_REDIRECT_URI || '/main/info'}`,
  postLogoutRedirectUri: `${getOrigin()}${env.keycloakAPI?.postLogoutRedirectUri || process.env.REACT_APP_KEYCLOAK_POST_LOGOUT_REDIRECT_URI || '/main/info'}`,
};

export const endpoints = {
  authorize: `${keycloakConfig.keycloakUrl}/realms/${keycloakConfig.realm}/protocol/openid-connect/auth`,
  token: `${keycloakConfig.keycloakUrl}/realms/${keycloakConfig.realm}/protocol/openid-connect/token`,
  userinfo: `${keycloakConfig.keycloakUrl}/realms/${keycloakConfig.realm}/protocol/openid-connect/userinfo`,
  logout: `${keycloakConfig.keycloakUrl}/realms/${keycloakConfig.realm}/protocol/openid-connect/logout`,
};

/**
 * Получить URL для авторизации через Keycloak
 */
export function getKeycloakLoginUrl() {
  // Генерируем state для безопасности (можно использовать для проверки на callback)
  const state = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  
  const params = new URLSearchParams({
    client_id: keycloakConfig.clientId,
    redirect_uri: keycloakConfig.redirectUri,
    response_type: 'code',
    scope: 'openid profile email',
    state: state, // Добавляем state для идентификации Keycloak callback
  });
  
  // Сохраняем state в sessionStorage для проверки на callback
  if (typeof window !== 'undefined') {
    sessionStorage.setItem('keycloak_state', state);
  }
  
  return `${endpoints.authorize}?${params.toString()}`;
}

/**
 * Проверить, является ли callback от Keycloak
 */
export function isKeycloakCallback(search, pathname) {
  const urlParams = new URLSearchParams(search);
  const state = urlParams.get('state');
  const source = urlParams.get('source');
  
  // Проверяем по параметру source
  if (source === 'keycloak') {
    return true;
  }
  
  // Проверяем по наличию state (Keycloak всегда возвращает state)
  // Если есть state и он сохранен в sessionStorage, это Keycloak callback
  if (state && typeof window !== 'undefined') {
    const savedState = sessionStorage.getItem('keycloak_state');
    if (savedState === state) {
      sessionStorage.removeItem('keycloak_state');
      return true;
    }
    // Если state есть, но не сохранен - все равно может быть Keycloak (если страница перезагружена)
    // Но лучше проверять по другим признакам
  }
  
  // Проверяем по пути (если есть отдельный путь для Keycloak)
  if (pathname?.includes('keycloak')) {
    return true;
  }
  
  // Если есть state параметр, скорее всего это Keycloak (Yandex не использует state)
  if (state) {
    return true;
  }
  
  return false;
}

/**
 * Получить URL для выхода из Keycloak
 */
export function getKeycloakLogoutUrl(idToken) {
  const params = new URLSearchParams({
    client_id: keycloakConfig.clientId,
    post_logout_redirect_uri: keycloakConfig.postLogoutRedirectUri || keycloakConfig.nextUrl,
  });
  
  if (idToken) {
    params.append('id_token_hint', idToken);
  }
  
  return `${endpoints.logout}?${params.toString()}`;
}

